import { Component, Inject } from '@angular/core';
import { Constant } from './../../constant';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonUtil } from '../../util/common-util';
import { ToastUtil } from '../../util/toast-util';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from './../../auth/auth.service';

@Component({
    selector: 'app-account-edit-dialog',
    templateUrl: './account-edit-dialog.component.html',
    styleUrl: './account-edit-dialog.component.css',
    standalone: false
})
export class AccountEditDialogComponent {
  public readonly Constant = Constant;
  public form: FormGroup;
  public isSaving = false;
  public maxLenColor = 6
  //public mainColor
  public colorPreviewId = 'main-color-preview'
  private apiPath = '/account';
  public roleOptions: { id: string; name: string; authority: number }[] = [];
  /** SP（767px以下）。役職の選択肢の一覧を、固定幅（352px）ではなく入力欄と同じ幅にする */
  public readonly isSp = window.matchMedia('(max-width: 767px)').matches;
  public mailaddress;
  public account;
  public showSpinner = true;
  public loginAuthCode: number;
  constructor(
    public dialogRef: MatDialogRef<AccountEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private auth: AuthService,
    private commonUtil: CommonUtil,
    private toastUtil: ToastUtil,
  ) {
    this.loginAuthCode = Number(this.auth.getAuthCode());
  }

  getAuthLabel(value: number | string) {
    const item = [
      { label: '管理', value: '0' },
      { label: '準管理', value: '1' },
      { label: '運用', value: '2' },
      { label: 'メンバー', value: '3' },
      { label: 'なし（未承認）', value: '4' }
    ].find(a => a.value === String(value));

    return item?.label ?? '';
  }

  // 役職の選択に紐づく権限（プレーンテキスト表示用）
  get selectedAuthorityLabel(): string {
    const roleId = this.form?.value?.officialposition;
    const role = this.roleOptions.find(r => String(r.id) === String(roleId));
    return role ? this.getAuthLabel(role.authority) : this.getAuthLabel(4);
  }

  // 役職が未選択（選択肢にない役職＝削除済み・選択不可の役職を含む）の場合は保存させない
  get isRoleSelected(): boolean {
    const roleId = this.form?.value?.officialposition;
    return roleId != null && this.roleOptions.some(r => String(r.id) === String(roleId));
  }

  ngOnInit() {
    if (!this.commonUtil.isOnline()) {
      this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
      this.dialogRef.close();
      return;
    }

    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);
      return this.commonUtil.apiGet('/master/5', options).then(res => {
        const roles: any[] = res.data?.master?.[5] ?? [];
        // 管理（0）以外は、自分より強い権限を持つ役職を選択肢から除外する
        this.roleOptions = roles
          .filter(r => this.loginAuthCode === 0 || r.authority > this.loginAuthCode)
          .map(r => ({ id: String(r.id), name: r.name, authority: r.authority }));

        if (this.data.id !== 0) {
          this.getDetail();
        } else {
          this.account = {
            mailaddress: Constant.empty,
          };
          this.initForm();
          this.showSpinner = false;
        }
      });
    })
    .catch(err => {
      // 役職マスタの取得に失敗した場合は、詳細取得（getDetail）と同じくダイアログを閉じる
      this.commonUtil.debug().log(err);
      if (err?.message === Constant.msgLoginFailed) {
        this.commonUtil.showReloadDialog(this.auth);
      } else {
        this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
        this.dialogRef.close();
      }
    });
  }

  onSave() {
    if (!this.commonUtil.checkOnline()) {
      this.isSaving = false;
      return;
    }

    if (this.isSaving) {
      return;
    }

    this.isSaving = true;
    if(this.data.id !== 0){
      this.dataUpdate();
    }
  }

  onInput() {
    const mail_address = this.form.value.mail_address;

    if (mail_address.length < 6) {
      return
    }

  }

  onChange() {
    const auth = this.form.value.accountAuth;

    if (auth.length < 6) {
      return
    }

  }

  onCompositionEnd() {
    this.onInput()
  }

    /* プライベート */
  // 詳細取得
  private getDetail() {
    if (!this.commonUtil.isOnline()) {
      this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
      this.dialogRef.close();
      return;
    }

    Auth.currentSession().then(session => {
      const apiPath = this.apiPath + '/detail/' + this.data.id;
      const options = this.auth.createApiHeader(session);
      this.commonUtil.apiGet(apiPath, options).then(res => {
        if (!res.data) {
          // 削除済み
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgDeleteAccountAlreadyError, Constant.toastShowMiliSec);
          this.dialogRef.close(true);
          return;
        }
        this.account = res.data;
        this.initForm();
        this.showSpinner = false;
      })
      .catch(err => {
        this.commonUtil.debug().log(err);
        if (err.message === Constant.msgLoginFailed) {
          this.commonUtil.showReloadDialog(this.auth);
        } else {
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
          this.dialogRef.close();
        }
      });
    });
  }

  private initForm() {
    this.form = new FormGroup({
      mailaddress: new FormControl(this.account.user_id, [Validators.required]),
      officialposition: new FormControl(
        this.account.officialposition != null ? String(this.account.officialposition) : null,
        Validators.required
      ),
    });
  }

  // 登録実行
  private dataUpdate() {
    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);
      options['body'] = {
        user_id: this.account.user_id,
        officialposition: this.form.value.officialposition
      };
      this.commonUtil
        .apiPut(this.apiPath + '/auth', options)
        .then(res => {
          if (res.status === Constant.OK) {
            this.toastUtil.showInformationToast('', Constant.msgResultChangerUserAuthSuccess, Constant.toastShowMiliSec);
            this.dialogRef.close(res.status);
          }
        })
        .catch(err => {
          this.commonUtil.debug().log(err);
          if (err.message === Constant.msgLoginFailed) {
            this.commonUtil.showReloadDialog(this.auth);
          } else if(err.message == "対象のユーザーが存在しません。") {
            this.toastUtil.showErrorToast('', Constant.msgDeleteAccountAlreadyError, Constant.toastShowMiliSec);
            this.dialogRef.close(Constant.NG);
          } else {
            this.toastUtil.showErrorToast('', Constant.msgSaveFailedRetry, Constant.toastShowMiliSec);
          }
          this.isSaving = false;
        });
    });
  }
}
